const TOKEN_KEY = 'access_token';
const ADMIN_KEY = 'is_admin';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const getAdminFlag = () => localStorage.getItem(ADMIN_KEY) === 'true';
export const setAdminFlag = () => localStorage.setItem(ADMIN_KEY, 'true');
export const clearAdminFlag = () => localStorage.removeItem(ADMIN_KEY);
export const clearAuth = () => {
  clearToken();
  clearAdminFlag();
};
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });
